import React from "react";

const SvgIcnProfile = props => (
  <svg
    id="icn_profile_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_profile_svg__cls-2{fill:#fff;fill-rule:evenodd}"}</style>
    </defs>
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      className="icn_profile_svg__cls-2"
      d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 20a9 9 0 1 1 9-9 9 9 0 0 1-9 9z"
    />
    <path
      className="icn_profile_svg__cls-2"
      d="M14.29 10.36a2.29 2.29 0 0 1-4.58 0A2.35 2.35 0 0 1 12 8a2.35 2.35 0 0 1 2.29 2.36zM8.14 20.62A4.43 4.43 0 0 0 12 23a4.43 4.43 0 0 0 3.86-2.38c0-4.1-1.75-7.41-3.86-7.41s-3.82 3.31-3.86 7.41z"
    />
  </svg>
);

export default SvgIcnProfile;
